module.exports = __webpack_public_path__ + "static/img/bg1.f17d99d9.png";